export default __webpack_public_path__ + "static/media/LoggingCamp.d69605fe.jpg";